/* eslint-disable no-unused-vars */

export const enum VIEW_MODE {
  CHAT = 'CHAT',
  PREVIEW_FILE = 'PREVIEW_FILE',
}

export enum ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
  DATA_ENTRY = 'DATA_ENTRY',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export enum TASK_FILE_STATUS {
  SELECTED = 'SELECTED',
  UPLOADED = 'UPLOADED',
  PROCESSED = 'PROCESSED',
  SAVED = 'SAVED',
}

export enum TRANSLATION_FILE_STATUS {
  SELECTED = 'SELECTED',
  IDLE = 'IDLE',
  UPLOADED = 'UPLOADED',
  UPDATED = 'UPDATED',
}

export enum UPLOAD_FILES_STATUS {
  IDLE = 'IDLE',
  UPLOADING = 'UPLOADING',
  FINISH = 'FINISH',
}

export enum CONVERSATION_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  GENERATE_ANSWER = 'GENERATE_ANSWER',
  ANSWERED = 'ANSWERED',
}

export enum TASK_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  GENERATE_ANSWER = 'GENERATE_ANSWER',
  ANSWERED = 'ANSWERED',
}

export enum TRANSLATED_FILE_STATUS {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  GENERATED = 'GENERATED',
}

export enum DOWNLOAD_TRANSLATED_FILE_STATUS {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
}

export enum DOCUMENT_TYPE {
  PDF = 'pdf',
  DOCX = 'docx',
  DOC = 'doc',
  XLSX = 'xlsx',
  XLS = 'xls',
  CSV = 'csv',
  PPT = 'ppt',
  PPTX = 'pptx',
  TSV = 'tsv',
  MARKDOWN = 'md',
  TXT = 'txt',
}

export enum DOCUMENT_FILE_STATUS {
  SELECTED = 'SELECTED',
  UPLOADED = 'UPLOADED',
  PROCESSED = 'PROCESSED',
  SAVED = 'SAVED',
}
